import { ApiResponse, TokenData, BlockingReason } from '../models';
import * as http from './http';
import ApiService from './service';

export class BlockingReasonService extends ApiService {
  public async loadAllBlockingReason() {
    const url = `${this.apiDomain}/api/settings/customer-blocking-reasons`;

    const resposne = await http.get<ApiResponse<BlockingReason[]>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }
  public async createBlockingReason(data: BlockingReason, id?: string) {
    const url = `${this.apiDomain}/api/settings/customer-blocking-reason`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async updateBlockingReason(data: BlockingReason, id?: string) {
    const url = `${this.apiDomain}/api/settings/customer-blocking-reason/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async deleteBlockingReason(id?: string) {
    const url = `${this.apiDomain}/api/settings/customer-blocking-reason/${id}`;

    const response = await http.remove<ApiResponse<BlockingReason>>(
      url,
      this.store
    );
    return response.data;
  }
}
